import { render, staticRenderFns } from "./lockscreen-2.vue?vue&type=template&id=bfe79a60&scoped=true"
import script from "./lockscreen-2.vue?vue&type=script&lang=js"
export * from "./lockscreen-2.vue?vue&type=script&lang=js"
import style0 from "./lockscreen-2.vue?vue&type=style&index=0&id=bfe79a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe79a60",
  null
  
)

export default component.exports